import { DARE_SUBMISSION_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[DARE_SUBMISSION_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		modalContent: {},
	},
}
